import {Directive, ElementRef, Input, OnChanges, SimpleChanges} from "@angular/core";
import {DashboardUtils} from "../../utils/dashboard-utils";
import * as fromStore from "../../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {User} from "../../../user/user";
import {Store} from "@ngrx/store";

@Directive({
    selector: '[dbWpLink]',
    standalone: false
})

export class WpLinkDirective implements OnChanges {

  @Input() adminLink: string;
  @Input() websiteId: number;
  public userEmail: string;


  constructor(
    private _elementRef: ElementRef,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser)),
        first((user: User) => !!user),
      )
      .subscribe((user: User) => {
        this.userEmail = user?.email;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['adminLink'] || changes['websiteId']) {
      const redirectorUrl: string = DashboardUtils.generateWpAdminRedirectorUrl(this.websiteId, this.adminLink, this.userEmail);
      this._elementRef.nativeElement.setAttribute('href', redirectorUrl);
    }
  }

}
